<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content d-flex flex-row" v-menu-permission="'list'">
            <DrawerHandler is-left class="col-lg-3 float-lg-left overflow-auto" style="height:750px" to-invisible>
                <!--EmFilterTree-->
                <em-filter-tree ref="emTree"
                                filterEnable checkEnable
                                :entity="modelName"
                                filterState="levelTreeFilter"
                                loadState="levelTreeNodes"
                                :selectedId="$_emLevelTreeListMixin_menuTreeSelectedId"
                                :node-appender="formatText"
                                textKeys="formattedText"
                                @onclick="$_emLevelTreeListMixin_menuTreeOnClick"></em-filter-tree>
            </DrawerHandler>
            <div class="float-lg-right col-lg-9">
                <div id="accordionFilter" class="content">
                    <div class="card">
                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                             data-parent="#accordionFilter">
                            <div class="card-body">
                                <form>
                                    <em-filter :entity="modelName" ref="emListFilter"
                                               @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="sithMomMainProjectPlanDetailResultTable" class="content">
                    <div class="card my-1">
                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                             data-parent="#accordionResult">
                            <div class="card-body">
                                <em-table :entity="modelName"
                                          ref="emTable" edit-disable
                                          withCustomRowActions :inlineActionsDisabled="prop_inline!=='1'"
                                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                    <template #left-header>
                                        <em-button type="check"
                                                   custom-label="启用"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   custom-icon="fa fa-fw fa-lg fa-check"
                                                   @click="handleEnable(true)"
                                                   :busy="onEnable"
                                        >
                                        </em-button>
                                        <em-button type="check"
                                                   custom-label="禁用"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   custom-icon="fa fa-fw fa-lg fa-close"
                                                   @click="handleEnable(false)"
                                                   :busy="onDisable"
                                        >
                                        </em-button>
                                    </template>
                                    <template #customRowActions="{row}">
                                        <b-button-group>
                                            <em-button
                                                v-if="$_emLevelTreeListMixin_getGrandParentId(row)"
                                                type="gotoGrandParent"
                                                v-bind:class="'btn btn-outline-primary btn-sm'"
                                                @click="$_emLevelTreeListMixin_gotoGrandParentLevel(row)">
                                            </em-button>
                                            <em-button type="gotoChild"
                                                       v-bind:class="'btn btn-outline-primary btn-sm'"
                                                       @click="$_emLevelTreeListMixin_gotoChild(row)">
                                            </em-button>
                                        </b-button-group>
                                    </template>
                                </em-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"/>
    </div>
</template>
<script>
// Author liang gang qiang
// Date 2023-09-27 08:20:53

import emLevelTreeListMixin from "@/mixin/em/levelTree/list";
import EmFilterTree from "@/components/em/EmFilterTree";
import EmFilter from "@/components/em/EmFilter";
import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";
import strUtil from "@/utils/strUtil";
import commonViewsUtil from "@/utils/commonViewsUtil";

export default {
    name: "sithMomMainProjectPlanDetailLevelTreeListView",
    mixins: [emLevelTreeListMixin],
    components: {DrawerHandler, EmFilter, EmFilterTree},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            onEnable: false,
            onDisable: false,
        }
    },
    methods: {
        formatText(nodeDate) {
            let formattedText = `${strUtil.getLast(nodeDate.activityId, '.')}:${nodeDate.chineseDescription || ''}`
            if (nodeDate.activeStatus !== 1) {
                return Object.assign({iconSkin: "minus1", formattedText}, nodeDate)
            } else
                return Object.assign({formattedText}, nodeDate)
        },

        handleEnable(enable = true) {
            let checkedNodes = this.$refs.emTree.getCheckedNodes();
            let tempList = []
            for (let item of checkedNodes) {
                tempList.push(item.id);
            }
            if (tempList.length === 0) {
                this.$message.warning("没有选择任何有效主计划详情");
                return;
            }
            enable ? this.onEnable = true : this.onDisable = true
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMESII_PLAN_URL + "/sithMomMainProjectPlanDetail/set/" + (enable ? 'activate' : 'deactivate'),
                data: tempList
            }).then(() => {
                commonViewsUtil.showSuccess(this, "操作成功")
                this.$refs.emListFilter.doQuery()
            }).finally(() => enable ? this.onEnable = false : this.onDisable = false)
        },
    }
}
</script>
